import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Stable state object so React Router doesn't see a new reference each render.
  const fromState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="animate-pulse text-zinc-500" data-testid="loading">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={fromState} replace />;
  if (user.must_set_password && location.pathname !== "/create-password") return <Navigate to="/create-password" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  if (!user.onboarded && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
};
